export const auditHistoryDrawerContent = {
  UPDATED_BY: 'User who made this update',
  UPDATED_DATE: 'Date/Time the update was made',
  FIELD: 'This indicates the data field which was changed/created',
  FROM: 'This is the previous value for the given field',
  TO: 'The value the field was updated to on this date/time',
}
